import { Provider } from '@angular/core';

import { AccountsService } from '@accounts/services/accounts.service';
import { ACCOUNTS_STORE } from '@accounts/stores/accounts.store';

export const ACCOUNTS_PROVIDERS: Provider[] = [AccountsService, ACCOUNTS_STORE];
